<div class="background"></div>
<div class="foreground">
  <load-guard [host]="this">
    @switch (state) {
      @case ('loading') {
        <app-spinner></app-spinner>
      }
      @case ('failed') {
        <div class="failed-to-load">
          <h1>Uh oh...</h1>
          <p>Looks like we're having trouble loading this right now.</p>

          <tyt-staging-note title="Details of error" [shown]="true">
            <pre>{{ errorMessage }}</pre>
          </tyt-staging-note>
        </div>
      }
      @case ('ready') {
        @if (hasPermissionToEdit && showEditControls) {
          <div class="page-actions">
            <div class="spacer"></div>
            <div class="indicator" matTooltip="These controls are only shown to TYT staff members with permission to edit the home page">
              <mat-icon>lock</mat-icon>
              Staff only
            </div>

            @if (staticContent) {
              <div class="indicator info" matTooltip="No dynamic home page has been defined. To customize the home page, create a page with URL '/home'.">
                <mat-icon>info</mat-icon>
                Static
              </div>
              <a mat-button [url]="createPageUrl" aria-label="Create Page" matTooltip="Create a new Page to replace the static home page">
                <mat-icon>edit</mat-icon>
                Create
              </a>
            } @else {
              @if (!page.is_published) {
                <div class="indicator warning" matTooltip="This page is not published! TYT.com will fall back to the static home page for non-staff users. Publish this page as soon as possible to correct the issue.">
                  <mat-icon>warning</mat-icon>
                  Unpublished
                </div>
              }

              <a mat-button routerLink="/pages/edit/{{page?.id}}">
                <mat-icon>edit</mat-icon>
                Edit
              </a>
            }

            <button mat-icon-button aria-label="Hide Controls" (click)="showEditControls = false" matTooltip="Hide Controls">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        }
      }
    }

    @if (blocks) {
      <tyt-content-view [class.hidden]="state !== 'ready'" [blocks]="blocks" (viewLoaded)="markReady()" />
      <tyt-awards></tyt-awards>
    }

  </load-guard>
</div>
